import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../../app/api/routes';
import { PRINCIPAL_DOCUMENTS_RESOURCE } from '../../constants';

export const REFRESH_PRINCIPAL_DOCUMENTS_RESOURCE = 'refreshPrincipalDocuments';

const principalDocumentsService = ComposedComponent =>
  reduxFetch([{
    resource: REFRESH_PRINCIPAL_DOCUMENTS_RESOURCE,
    method: 'get',
    request: (principalId, filters) => ({
      url: addParametersToUri(apiRoutes.principalDocuments(principalId), filters),
      meta: {
        setOther: {
          resource: `${PRINCIPAL_DOCUMENTS_RESOURCE}_${principalId}`,
        },
      },
    }),
  }])(ComposedComponent);

export default principalDocumentsService;
